var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_10457_3222)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.86719 31.6359L9.58208 25.4087C8.52186 23.5808 7.96568 21.5108 7.97147 19.3947C7.97147 12.7638 13.3942 7.37256 20.051 7.37256C23.2838 7.37256 26.3196 8.62378 28.5965 10.8956C30.8791 13.1674 32.1363 16.1888 32.1306 19.4005C32.1306 26.0314 26.7078 31.4226 20.0452 31.4226H20.0394C18.0175 31.4226 16.0303 30.9152 14.2633 29.958L7.86719 31.6359ZM14.5703 27.7843L14.9353 28.0034C16.4764 28.9144 18.2434 29.393 20.0452 29.3987H20.051C25.5838 29.3987 30.0912 24.9185 30.0912 19.4062C30.0912 16.7366 29.0484 14.2284 27.1539 12.3371C25.2594 10.4458 22.7334 9.40796 20.051 9.40796C14.5182 9.4022 10.0108 13.8824 10.0108 19.3947C10.0108 21.2802 10.538 23.1195 11.5461 24.711L11.7836 25.0915L10.7698 28.776L14.5703 27.7843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.28906 31.215L9.94602 25.2011C8.92056 23.4424 8.38176 21.4416 8.38176 19.4004C8.38755 13.0002 13.6191 7.79346 20.05 7.79346C23.1727 7.79346 26.0984 9.00432 28.3 11.1954C30.5015 13.3865 31.7124 16.3041 31.7124 19.4062C31.7124 25.8065 26.475 31.0132 20.05 31.0132H20.0442C18.0917 31.0132 16.1741 30.5231 14.4708 29.6005L8.28906 31.215Z",
    fill: "url(#paint1_linear_10457_3222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.86719 31.6359L9.58208 25.4087C8.52186 23.5808 7.96568 21.5108 7.97147 19.3947C7.97147 12.7638 13.3942 7.37256 20.051 7.37256C23.2838 7.37256 26.3196 8.62378 28.5965 10.8956C30.8791 13.1674 32.1363 16.1888 32.1306 19.4005C32.1306 26.0314 26.7078 31.4226 20.0452 31.4226H20.0394C18.0175 31.4226 16.0303 30.9152 14.2633 29.958L7.86719 31.6359ZM14.5703 27.7843L14.9353 28.0034C16.4764 28.9144 18.2434 29.393 20.0452 29.3987H20.051C25.5838 29.3987 30.0912 24.9185 30.0912 19.4062C30.0912 16.7366 29.0484 14.2284 27.1539 12.3371C25.2594 10.4458 22.7334 9.40796 20.051 9.40796C14.5182 9.4022 10.0108 13.8824 10.0108 19.3947C10.0108 21.2802 10.538 23.1195 11.5461 24.711L11.7836 25.0915L10.7698 28.776L14.5703 27.7843Z",
    fill: "url(#paint2_linear_10457_3222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.031 14.3665C16.805 13.8649 16.5675 13.8533 16.3531 13.8476C16.1793 13.8418 15.9766 13.8418 15.7738 13.8418C15.571 13.8418 15.2466 13.9168 14.9685 14.2166C14.6904 14.5164 13.9141 15.2429 13.9141 16.7248C13.9141 18.2009 14.9975 19.6309 15.1481 19.8327C15.2987 20.0345 17.2396 23.1654 20.3043 24.3705C22.8535 25.3738 23.3749 25.172 23.9253 25.1201C24.4757 25.0682 25.7097 24.3936 25.9646 23.6902C26.2138 22.9867 26.2138 22.387 26.1384 22.2602C26.0631 22.1333 25.8604 22.0584 25.5591 21.9085C25.2578 21.7585 23.7747 21.032 23.4966 20.9282C23.2185 20.8302 23.0157 20.7783 22.8187 21.0781C22.616 21.378 22.0366 22.0526 21.8628 22.2544C21.689 22.4562 21.5094 22.4793 21.2081 22.3294C20.9069 22.1795 19.9336 21.8623 18.7806 20.836C17.8826 20.0403 17.2743 19.0543 17.1005 18.7544C16.9267 18.4546 17.0831 18.2932 17.2338 18.1432C17.367 18.0106 17.535 17.7915 17.6857 17.6185C17.8363 17.4456 17.8884 17.3187 17.9869 17.1169C18.0854 16.9151 18.0391 16.7421 17.9638 16.5922C17.8884 16.448 17.2975 14.9604 17.031 14.3665Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10457_3222",
    x1: 19.999,
    y1: 39.998,
    x2: 19.999,
    y2: -0.0013995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10457_3222",
    x1: 20.0001,
    y1: 31.2138,
    x2: 20.0001,
    y2: 7.79264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10457_3222",
    x1: 20.0012,
    y1: 31.6337,
    x2: 20.0012,
    y2: 7.37256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.87a7fad5fb75dfe0ab45e90b2c2ab0d5.svg";
export { ForwardRef as ReactComponent };